export default __webpack_public_path__ + "static/media/GF_ANDY_FURY.002e5154.jpg";